<template>
   <el-container class="wrapper" id="index1">
     <div class="main-page">
       <el-header><HeaderDom></HeaderDom></el-header>
       <el-container>
         <el-aside :width="asideWith">
           <!--MenuDom></MenuDom>-->
           <AsideDom></AsideDom>
         </el-aside>
         <!-- <el-main class="content-box" :class="{'content-collapse':collapse}"> -->
         <!-- 首页菜单伸缩，其他功能菜单伸缩 by li.xue 2019/7/11-->
         <el-main class="content-box" :class="collapseStyle">
           <div class="content">
             <Breadcrumb v-if="!noBread"></Breadcrumb>
             <transition name="move" mode="out-in">
               <div class="content-body mini-scroller">
                 <keep-alive>
                   <router-view v-if="$route.meta.keepAlive"></router-view>
                 </keep-alive>
                 <router-view v-if="!$route.meta.keepAlive"></router-view>
               </div>
             </transition>
           </div>
         </el-main>
       </el-container>
     </div>
  </el-container>
</template>

<script>
//引入Header Component
import HeaderDom from '@/views/common/layout/HeadDom'
//引入一级Menu Component
import MenuDom from '@/views/common/layout/MenuDom'
//引入Aside Component
import AsideDom from '@/views/common/layout/AsideDom'
//引入面包屑Breadcrumb
import Breadcrumb from '@/components/breadcrumb'
import bus from '../../common/js/bus';
export default {
	name:"index1",
  data(){
    return {
      collapse: false,
      noBread: false,
      asideWith: "240px"
    }
  },
  components: {
    HeaderDom,
    MenuDom,
    AsideDom,
    Breadcrumb
  },
  computed: {
    routes() {
      return this.$router.options.routes;
    },
    collapseStyle() {
      /**首页伸缩 by li.xue 2019/12/25 */
      if(this.$route.path == '/home' || this.$route.path == '/homeUser' || this.$route.path == '/homeBuild'){
        this.noBread = true;
        this.asideWith = "0px";
        return "content-collapse1";
      }else{
        this.asideWith = "240px";
        this.noBread = false;
        if(this.collapse){
          return "content-collapse";
        }else{
          return "content-collapse2";
        }
      }
      /**
      if(this.collapse){
        return "content-collapse";
      }else{
        return "content-collapse2";
      } */
    },
  },
  created(){
    bus.$on('collapse', msg => {
        this.collapse = msg;
    })
  }
};
</script>
<style lang="scss">
	#index1{
	.el-header,.el-footer {
	  background: url(../../../static/images/home/icn_bg.png) no-repeat;
	  background-size: cover;
	  color: #333;
	  text-align: center;
	  line-height: 50px;
	}
	.el-header{
	  padding:0 !important;
	  height:5rem !important;
	  flex-shrink: 0;
	}
	.el-main {
	  padding: 0 !important;
	  font-size: 14px;
	}
	.content-box {
	  position: absolute;
	  left: 240px;
	  right: 0;
	  top: 5rem;
	  bottom: 0;
	  padding-bottom: 0px;
	  -webkit-transition: left .3s ease-in-out;
	  transition: left .3s ease-in-out;
	  background: #F4F8F8;
	  display: flex;
	  flex-direction: column;
	  overflow-y: auto;
	}
	.content {
	  position: relative;
	  display: flex;
	  flex: 1;
	  flex-direction: column;
	  box-sizing: border-box;
	  width: auto;
	  height: 100%;
	  overflow-y: auto;
	  padding: 10px 20px 5px 20px;
	  margin: 0;
	}
	.content-body {
	  position:relative;
	  flex:1;
	  overflow-y: auto;
	}
	.content-collapse {
	  left: 65px;
	}
	.content-collapse1 {
	  left: 0px;
	}
	.content-collapse2 {
	  left: 240px;
	}
	.container {
	  padding: 30px;
	  background: #fff;
	  border: 1px solid #ddd;
	  border-radius: 5px;
	}
	.wrapper {
	  width: 100%;
	  height: 100%;
	  overflow: hidden;
	}
	.main-page {
	  display: flex;
	  flex-direction: column;
	  width: 100%;
	  .el-aside {
	    height: calc(100vh - 80px);
	    overflow-x: hidden;
	    background: #fff;
	
	    &::-webkit-scrollbar-button {
	      width: 0px;
	      height: 0px;
	    }
	    &::-webkit-scrollbar-track {
	      background: transparent;
	    }
	    &::-webkit-scrollbar {
	      width: 2px;
	      height: 2px;
	    }
	    &::-webkit-scrollbar-thumb {
	      background: rgba(0, 0, 0, 0.2);
	      border: thin solid rgba(255,255,255,0);
	    }
	  }
	  .el-aside::-webkit-scrollbar {/*滚动条整体样式*/
	     width: 0px;     /*高宽分别对应横竖滚动条的尺寸*/
	     height: 0px;
	   }
		
	}
}
</style>



// WEBPACK FOOTER //
// src/views/common/Index.vue